export const clientUserBranchAccessesTableColumns = [
  { label: 'Usuário', value: 'user' },
  { label: 'Permissão', value: 'branch_hierarchy_for_user_access' },
  { label: 'Ações', value: 'actions', className: 'w-11' },
];
